import {
	AlertDescription,
	AlertTitle,
	Alert as AlertComponent,
} from "@/components/ui/alert"
import { PaymentStatus } from "@/types/form-types"

type Props = {
	title: string
	message: string
	status: PaymentStatus
}

const Alert = ({ title, message, status }: Props) => {
	const className = () => {
		switch (status) {
			case PaymentStatus.ORDER_CREATED_PENDING_LOAN_APPROVAL:
				return "bg-[#EDCB3A80]/50 text-[#765F00] border-[#765F00]"
			case PaymentStatus.ORDER_CREATED_LOAN_REJECTED:
				return "bg-[#EC003F80]/50 text-[#EC003F] border-[#EC003F]"
			case PaymentStatus.LOAN_APPROVED_PENDING_LOAN_DISBURSEMENT:
				return "bg-[#89D09C80]/50 text-[#189842] border-[#189842]"
			case PaymentStatus.LOAN_DISBURSEMENT_RECEIVED:
				return "bg-[#89D09C80]/50 text-[#189842] border-[#189842]"
		}
	}
	return (
		<AlertComponent
			variant={"default"}
			className={className() + " px-4 py-5"}
		>
			<AlertTitle>{title}</AlertTitle>
			<AlertDescription>{message}</AlertDescription>
		</AlertComponent>
	)
}
export default Alert
